<script>
    let decided = localStorage.getItem("privacyConsent") != null;

	function onAccept() {
		localStorage.setItem("privacyConsent", "true");
        decided = true;
	}

    function onDecline() {
		localStorage.setItem("privacyConsent", "false");
        decided = true;
	}
</script>

<style>
    .container {
        position: fixed;
        width: 450px;
        height: 90px;
        right: 0;
        bottom: 100px;
        z-index: 1000;
        display: flex;
        flex-flow: column;
        padding: 20px;
        background: #023047;
        border-radius: 15px 0 0 15px;
        border: 1px solid #FFFFFF30;
        border-right: none;
        box-shadow: 0px 10px 45px #00000088;
        font-size: 15px;
        line-height: 140%;
        font-weight: 300;
    }

    @media (max-width: 450px) {
        .container {
            width: 100%;
            height: auto;
            border-radius: 0;
            border-left: none;
            bottom: 0;
        }
	}

    .buttons {
        display: flex;
        flex-flow: row;
        font-weight: normal;
    }

    .button {
        padding: 5px 15px 5px 15px;
        margin-top: 10px;
        margin-right: 20px;
        background: white;
        color: #023047;
        border-radius: 10px;
        cursor: pointer;
        width: 90px;
        text-align: center;
    }
    
    a {
        font-size: 13px;
        font-weight: bold;
    }

    a:hover {
        text-decoration: underline;
    }
</style>

{#if !decided}
    <div class="container">
        <div>
            By navigating this website you agree to our cookie policy.
        </div>
        <a href="#/legal/privacy-policy">Read more</a>
        <div class="buttons">
            <div class="button" on:click={onAccept}>OK</div>
            <div class="button" on:click={onDecline}>Decline</div>
        </div>
    </div>
{/if}
